import { Point } from "@noya-app/noya-geometry";

// MIT https://github.com/pmndrs/use-gesture

// wheel delta defaults from https://github.com/facebookarchive/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
const LINE_HEIGHT = 40;
const PAGE_HEIGHT = 800;

export function wheelValues(event: WheelEvent): Point {
  let { deltaX, deltaY, deltaMode } = event;
  // normalize wheel values, especially for Firefox
  if (deltaMode === 1) {
    deltaX *= LINE_HEIGHT;
    deltaY *= LINE_HEIGHT;
  } else if (deltaMode === 2) {
    deltaX *= PAGE_HEIGHT;
    deltaY *= PAGE_HEIGHT;
  }
  return { x: deltaX, y: deltaY };
}
